import React, { forwardRef } from "react";
import { Button, ButtonProps } from "../Button/Button";
import { cx } from "../../utils";

const tones = {
  bare: "",
  raised: "bg-player-raised text-player-text",
  surface: "bg-player-surface text-player-text",
  muted: "bg-player-border text-player-text",
  inverted: "bg-white text-black",
};
const sizes = { bare: "", sm: "h-12 w-12", md: "h-14 w-14", lg: "h-16 w-16" };
export type IconButtonProps = Omit<ButtonProps, "size"> & {
  label: string; tone?: keyof typeof tones; size?: keyof typeof sizes;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, variant = "ghost", tone = "bare", size = "bare", className, ...props }, ref,
) {
  return <Button ref={ref} variant={variant} size="none" aria-label={label} className={cx(
    size !== "bare" && "flex items-center justify-center rounded-full", tones[tone], sizes[size], className,
  )} {...props} />;
});
